import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DocumentItem } from '@klubovna/shared-models';
import { Observable } from 'rxjs';
import * as DocumentsActions from './documents.actions';
import * as DocumentsSelectors from './documents.selectors';
import { DocumentsState } from './documents.state';

@Injectable({
  providedIn: 'root',
})
export class DocumentsFacade {
  private store: Store<DocumentsState> = inject(Store<DocumentsState>);

  documents$: Observable<DocumentItem[]> = this.store.select(DocumentsSelectors.selectAllDocuments);
  loading$: Observable<boolean> = this.store.select(DocumentsSelectors.selectDocumentsLoading);
  error$: Observable<string | null> = this.store.select(DocumentsSelectors.selectDocumentsError);

  loadDocuments(): void {
    this.store.dispatch(DocumentsActions.loadDocuments());
  }

  getDocumentByIdentifier(identifier: string): Observable<DocumentItem | null> {
    return this.store.select(DocumentsSelectors.getDocumentByIdentifier(identifier));
  }
}
